import React, { useState, useEffect } from "react";
import "./MouCollaborations.scss";

import mouTribalAffairs from "../assets/mou/mou-tribal-affairs.jpg";
import mouNielit from "../assets/mou/mou-nielit.jpg";

const MOUS = [
  {
    src: mouTribalAffairs,
    alt: "Cograd signs MoU with Ministry of Tribal Affairs to empower tribal education through AI",
    title: "Ministry of Tribal Affairs (EMRS)",
    caption: "Empowering Tribal Education Through AI",
  },
  {
    src: mouNielit,
    alt: "Cograd signs MoU with NIELIT to advance India's digital learning ecosystem",
    title: "NIELIT",
    caption: "Advancing India's Digital Learning Ecosystem",
  },
];

export default function MouCollaborations() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setActive(null);
    };
    if (active !== null) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [active]);

  return (
    <section className="mou">
      <div className="mou__head">
        <span className="mou__chip">Recent Collaborations</span>
        <h2 className="mou__title">
          Partnering to <span>Transform Education</span>
        </h2>
        <p className="mou__sub">
          Cograd has signed MoUs with leading government bodies to bring AI-powered
          learning and future-ready skills to schools across India.
        </p>
      </div>

      <div className="mou__grid">
        {MOUS.map((m, i) => (
          <figure
            className="mou__card"
            key={i}
            onClick={() => setActive(i)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" ? setActive(i) : null)}
          >
            <img className="mou__img" src={m.src} alt={m.alt} loading="lazy" />
            <span className="mou__zoom" aria-hidden="true">⤢</span>
            <figcaption className="mou__cap">
              <span className="mou__cap-title">{m.title}</span>
              <span className="mou__cap-text">{m.caption}</span>
            </figcaption>
          </figure>
        ))}
      </div>

      {active !== null && (
        <div className="mou__lightbox" onClick={() => setActive(null)}>
          <button
            className="mou__close"
            onClick={() => setActive(null)}
            aria-label="Close"
          >
            ×
          </button>
          <img
            className="mou__lightbox-img"
            src={MOUS[active].src}
            alt={MOUS[active].alt}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
